import { ActionType, IPreviewProduct, IProduct, IProductForm } from './model'
import { Action, DEFAULT_ENTITY_ITEM_LIST, DEFAULT_ITEM_LIST, IEntityList, IItemList, Nullable } from '../model'
import createReducer from '../createReducer'
import { IBigBannerSlide } from '@centra/centra-ui/dist/molecules/BigBanner/_Slide/models'

export interface IStoreReducer {
  products: {
    [key: string]: IItemList<IProduct>
  }
  productList: IItemList<IProduct>
  previewProduct: Nullable<IPreviewProduct>
  product: Nullable<IProduct>
  productNew: Nullable<IProduct>
  banner: IEntityList<IBigBannerSlide>
  freshlyProductsCount?: number
}

const defaultState: IStoreReducer = {
  products: {},
  productList: DEFAULT_ITEM_LIST,
  previewProduct: null,
  product: null,
  productNew: null,
  banner: DEFAULT_ENTITY_ITEM_LIST,
}

export const storeReducer = createReducer<IStoreReducer>(defaultState, {
  [ActionType.SET_PREVIEW_PRODUCT](state: IStoreReducer, action: Action<Nullable<IProductForm>>) {
    return { ...state, previewProduct: action.payload }
  },

  [ActionType.GET_PRODUCT](state: IStoreReducer) {
    return { ...state, product: null }
  },

  [ActionType.SET_PRODUCT](state: IStoreReducer, action: Action<Nullable<IProduct>>) {
    return { ...state, product: action.payload }
  },

  [ActionType.GET_PRODUCT_NEW](state: IStoreReducer) {
    return { ...state, productNew: null }
  },

  [ActionType.SET_PRODUCT_NEW](state: IStoreReducer, action: Action<Nullable<IProduct>>) {
    return { ...state, productNew: action.payload }
  },

  [ActionType.GET_PRODUCT_LIST](state: IStoreReducer, action: Action<{ page: number }>) {
    const { payload } = action
    if (payload.page) {
      return { ...state }
    }
    return { ...state, productList: DEFAULT_ITEM_LIST }
  },

  [ActionType.SET_PRODUCT_LIST](state: IStoreReducer, action: Action<IProduct[]>) {
    return { ...state, productList: action.payload }
  },
})
